export default __webpack_public_path__ + "static/media/twentyeightdays5.71a14cc5.jpg";